import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Link} from 'react-router-dom';

import workList from '../db/work.json';



function WorkDetail() {

    const workId = useParams().workId;

    let [scroll, setScroll] = useState(0);

    const scrollX=(e)=>{ 
        const main = document.querySelector('main');
        const scroll_bar = document.querySelector('.scroll_bar');
        
        setScroll( scroll += Math.sign(e.deltaY)*100 );
        
        if(scroll < 0){
            scroll = 0;
        }else if(scroll > main.clientWidth - window.innerWidth){
            scroll = main.clientWidth - window.innerWidth;
        }
        
        main.style.left = -(scroll) +'px';
        scroll_bar.style.width = `${scroll / (main.clientWidth - window.innerWidth) * 100}%`;
    }

    useEffect(()=>{
        window.addEventListener('wheel',scrollX);
        return ()=>{
            window.removeEventListener('wheel',scrollX);
        }
    },[]);

    const thumbWidth = {
        width:'150vw',
    }

    return (
        <>
            {workList[workId].map(detail=>(
                <main id="detail" className="overflow-hidden flex flex-nowrap w-max relative">
                    <section className="h-screen w-screen pt-16 pb-4 flex relative after:content-['scroll'] after:text-white after:absolute after:right-4 after:bottom-4">
                        <p className="text-6xl pl-7 w-3/12">{detail.num}</p>
                        <h3 className="text-6xl w-9/12">
                            {detail.name}
                        </h3>
                        <div className="absolute h-1/2 bottom-0 w-full bg-black" style={{backgroundColor:`${detail.main_bg}`}}></div>
                    </section>
                    <section id="thumb" className="h-screen pt-16 pb-4 pl-16 relative bg-neutral-700" style={thumbWidth}>
                        <div className="relative z-40 flex flex-col h-full w-2/5 whitespace-pre-line">
                            <h4 className="text-3xl text-white">{detail.project}</h4>
                            <p className="text-3xl text-white">{detail.duration}</p>
                            <p className="text-xl text-white font-extralight mt-4">{detail.summary}</p>
                            <Link to={detail.link} target="_blank" className="view_btn flex text-5xl relative text-white mt-auto items-center hover:text-cyan-200 group">
                                VIEW
                                <svg width="95" height="94" viewBox="0 0 95 94" xmlns="http://www.w3.org/2000/svg" className="ml-2 fill-white group-hover:fill-cyan-200">
                                    <rect x="17" width="78" height="10"/>
                                    <rect x="85" width="10" height="78"/>
                                    <rect x="85.3555" y="2" width="10" height="120" transform="rotate(45 85.3555 2)"/>
                                </svg>
                            </Link>
                        </div>
                        <div className="absolute w-2/3 h-full left-1/2 top-16 bg_area drop-shadow-lg flex flex-wrap justify-between">
                            <div className="main_page w-[calc(75%-20px)] h-[calc(100%-4rem)]">
                                <img src={`${process.env.PUBLIC_URL}/images/${detail.img_main}`} alt="" className="w-full h-full object-cover object-top" />
                            </div>
                            <div className="sub_page flex flex-col w-1/4 h-[calc(100%-4rem)]">
                                <div className="sub_01 w-full h-[calc(50%-10px)]">
                                    <img src={`${process.env.PUBLIC_URL}/images/${detail.img_sub1}`} alt="" className="w-full h-full object-cover object-top" />
                                </div>
                                <div className="sub_02 w-full mt-auto h-[calc(50%-10px)]">
                                    <img src={`${process.env.PUBLIC_URL}/images/${detail.img_sub2}`} alt="" className="w-full h-full object-cover object-top" />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="h-screen w-screen pt-16 pb-4 flex bg-neutral-700">
                        <div className="ml-auto w-8/12 h-full flex flex-col">
                            <h5 className="text-3xl text-white">
                                작업범위
                            </h5>
                            <ul className="mt-auto">
                                <li className="py-2 border-b-2 px-4 flex text-white items-center">
                                    <h4 className="text-6xl w-1/3 text-cyan-200">{detail.plan_per}</h4>
                                    <p className="font-extralight w-2/3">
                                        <span className="font-bold">기획&middot;분석</span>
                                        <br />
                                        {detail.plan_txt}
                                    </p>
                                </li>
                                <li className="py-2 border-b-2 px-4 flex text-white items-center">
                                    <h4 className="text-6xl w-1/3 text-cyan-200">{detail.design_per}</h4>
                                    <p className="font-extralight w-2/3">
                                        <span className="font-bold">설계&middot;디자인</span>
                                        <br />
                                        {detail.design_txt}
                                    </p>
                                </li>
                                <li className="py-2 px-4 flex text-white items-center">
                                    <h4 className="text-6xl w-1/3 text-cyan-200">{detail.publish_per}</h4>
                                    <p className="font-extralight w-2/3">
                                        <span className="font-bold">퍼블리싱, 웹표준</span>
                                        <br />
                                        {detail.publish_txt}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </section>
                </main>
            ))}
            <div className="scroll_area fixed bottom-0 w-screen h-2 bg-slate-300">
                <div className="scroll_bar bg-cyan-400 h-full w-0"></div>
            </div>
        </>
    );
}

export default WorkDetail;